// Used in assignment-info-dialog.component.html and tiles.component.html

// Angular
import { Component, Input, OnInit } from "@angular/core";

@Component({
    selector: "bundle-skills",
    templateUrl: "./bundle-skills.component.html",
    styleUrls: [
        "./bundle-skills.component.scss",
        "../../../styles/shared-styles.scss",
    ],
    standalone: false
})
export class BundleSkillsComponent implements OnInit {
    @Input() skills: any;
    @Input() fontSize: string;

    constructor() {}

    ngOnInit(): void {}
}
